export const feedbacks = {
  items: [
    {
      id: 'fd001',
      title: 'Впровадити гнучкий графік роботи',
      content:
        'Деякі працівники вважають, що можливість обирати час початку робочого дня покращить продуктивність і задоволеність. Було б зручно мати гнучкий графік — наприклад, можливість починати роботу між 8:00 та 10:00, залежно від особистого ритму та обставин. Це дозволить краще балансувати роботу й особисте життя, зменшить стрес і підвищить мотивацію. Можна також протестувати цю ідею в окремих командах або встановити певні дні з гнучким стартом для початку.',
      state: 'unread',
      upvotesCount: 12,
      downvotesCount: 2,
      userVoteType: null,
      creatorName: 'Оксана Литвиненко',
      createdAt: '2025-04-20T10:20:00Z',
      updatedAt: '2025-04-21T08:00:00Z',
    },
    {
      id: 'fd002',
      title: 'Організувати тижневі міні-збори команд',
      content:
        'Короткі щотижневі зустрічі допоможуть підтримувати зв’язок та розуміння цілей. Було б корисно запровадити 15-хвилинні командні стендапи щопонеділка, де кожен коротко ділиться пріоритетами на тиждень. Це допоможе синхронізуватись, швидко виявляти блокери та краще розуміти, над чим працюють колеги. Можна почати з тестового формату на кілька тижнів і зібрати зворотний зв’язок.',
      state: 'unread',
      upvotesCount: 8,
      downvotesCount: 0,
      userVoteType: null,
      creatorName: 'Іван Мельник',
      createdAt: '2025-04-18T14:45:00Z',
      updatedAt: '2025-04-19T09:30:00Z',
    },
    {
      id: 'fd003',
      title: 'Запровадити внутрішню платформу для обміну знаннями',
      content:
        'Було б чудово мати внутрішню платформу або регулярні міні-сесії, де кожен може поділитись експертизою — наприклад, короткі воркшопи або "п’ятничні знання". Це не лише посилить внутрішній розвиток, а й допоможе краще пізнати одне одного як професіоналів',
      state: 'read',
      upvotesCount: 15,
      downvotesCount: 1,
      userVoteType: 'upvote',
      creatorName: 'Наталя Шевченко',
      createdAt: '2025-04-17T11:00:00Z',
      updatedAt: '2025-04-18T12:10:00Z',
    },
    {
      id: 'fd004',
      title: 'Покращити якість комунікації між відділами',
      content: 'Пропонується використовувати спільні чат-канали та регулярні апдейти між командами.',
      state: 'unread',
      upvotesCount: 6,
      downvotesCount: 3,
      userVoteType: 'downvote',
      creatorName: 'Юрій Гринь',
      createdAt: '2025-04-16T09:25:00Z',
      updatedAt: '2025-04-16T15:40:00Z',
    },
    {
      id: 'fd005',
      title: 'Додати бонусну систему за ініціативність',
      content:
        'Можна запровадити просту систему подяк або бонусів за активність — наприклад, за ініціативи, менторство або допомогу колегам. Навіть символічні відзнаки, як-от "герой тижня" чи невеликі подарунки, зроблять участь у внутрішньому житті приємнішою й більш мотивуючою',
      state: 'unread',
      upvotesCount: 10,
      downvotesCount: 0,
      userVoteType: null,
      creatorName: 'Марина Коваль',
      createdAt: '2025-04-15T16:00:00Z',
      updatedAt: '2025-04-16T10:15:00Z',
    },
    {
      id: 'fd006',
      title: 'Зменшити кількість непотрібних мітингів',
      content:
        'Іноді замість загальних дзвінків зручніше мати асинхронні оновлення — наприклад, у вигляді коротких нотаток у Notion або Slack-повідомлень. Це заощадить час і дозволить кожному ознайомитися з інформацією у зручний момент, не перериваючи робочий ритм.',
      state: 'read',
      upvotesCount: 11,
      downvotesCount: 2,
      userVoteType: 'upvote',
      creatorName: null,
      createdAt: '2025-04-14T13:00:00Z',
      updatedAt: '2025-04-14T17:45:00Z',
    },
    {
      id: 'fd007',
      title: 'Облаштувати зону відпочинку в офісі',
      content:
        'Простір для неформального спілкування допоможе зняти стрес та сприятиме командному духу. Було б корисно мати окремі канали або події для неформального обміну — наприклад, щомісячні онлайн-кави, командні квізи чи просто чат рандомних для фото з подорожей або мемів. Такі ініціативи допоможуть легше знайомитись, підтримувати теплі стосунки в команді й покращити атмосферу на роботі.',
      state: 'unread',
      upvotesCount: 7,
      downvotesCount: 1,
      userVoteType: null,
      creatorName: null,
      createdAt: '2025-04-13T12:15:00Z',
      updatedAt: '2025-04-13T16:30:00Z',
    },
  ],
  meta: {
    total: 7,
    page: 1,
    limit: 10,
  },
};
